import angular from 'angular';

import {
  LoadingOverlayModule,
  UFaIconComponent,
  UButtonGroupComponent,
  ChangeModule,
} from '@updater/angular-common';

import { AddressModule } from '@updater-components/address';
import { StepPageModule } from '../../common/directives/step-page';
import { CardModule } from '../../core';
import { OfferCardModule } from '../../common/directives/offer-card';
import { GoogleStarsModule } from '../../common/directives/google-stars';
import digits from '../../common/filters';
import { MovingCenterConfig } from './moving-center.config';
import { defineMovingCenterRoles } from './moving-center.roles';
import { MovingCenterOfferCardComponent } from './offer-card';
import { MoveKindToggleComponent } from './move-kind-toggle';
import { MovingCenterActionsModule } from '../../../state/moving-center';
import '@updater-components/radio-group';

import { MovingCenterFormConfig, MovingCenterFormComponent } from './form';

import { MovingCenterDiyConfig, MovingCenterDiyComponent } from './diy';

import {
  MovingCenterCompaniesConfig,
  MovingCenterCompaniesComponent,
} from './companies';

export const MovingCenterStepModule = angular
  .module('app.steps.moving-center', [
    AddressModule.name,
    LoadingOverlayModule.name,
    UFaIconComponent.name,
    UButtonGroupComponent.name,
    StepPageModule.name,
    CardModule.name,
    OfferCardModule.name,
    GoogleStarsModule.name,
    digits.name,
    MovingCenterActionsModule.name,
    ChangeModule.name,
  ])
  .config(MovingCenterConfig)
  .config(MovingCenterFormConfig)
  .config(MovingCenterDiyConfig)
  .config(MovingCenterCompaniesConfig)
  .component('updMovingCenterForm', MovingCenterFormComponent)
  .component('updMovingCenterDiy', MovingCenterDiyComponent)
  .component('updMovingCenterCompanies', MovingCenterCompaniesComponent)
  .component('updMovingCenterOfferCard', MovingCenterOfferCardComponent)
  .component('updMoveKindToggle', MoveKindToggleComponent)
  .run(defineMovingCenterRoles);
